/**
 * NSM sponsors — single source of truth for partners/sponsors section.
 * Uses real logo files from src/assets/sponsors/.
 */

import brand11 from "../assets/sponsors/brand-1-1.png";
import brand12 from "../assets/sponsors/brand-1-2.png";
import brand13 from "../assets/sponsors/brand-1-3.png";
import brand14 from "../assets/sponsors/brand-1-4.png";
import brand15 from "../assets/sponsors/brand-1-5.png";
import brand122 from "../assets/sponsors/brand-1-22.png";
import brand01 from "../assets/sponsors/brand-01.png";

export const sponsors = [
  { name: "Official Partner 01", image: brand11, alt: "Official Partner 01 — Next Super Model", url: null },
  { name: "Official Partner 02", image: brand12, alt: "Official Partner 02 — Next Super Model", url: null },
  { name: "Official Partner 03", image: brand13, alt: "Official Partner 03 — Next Super Model", url: null },
  { name: "Official Partner 04", image: brand14, alt: "Official Partner 04 — Next Super Model", url: null },
  { name: "Official Partner 05", image: brand15, alt: "Official Partner 05 — Next Super Model", url: null },
  { name: "Official Partner 06", image: brand122, alt: "Official Partner 06 — Next Super Model", url: null },
  { name: "Official Partner 07", image: brand01, alt: "Official Partner 07 — Next Super Model", url: null },
];

export default sponsors;
